import { readLocalStorageValue, useLocalStorage } from '@mantine/hooks'
import { Label as AriaLabel } from 'react-aria-components'
import { UICheckbox } from 'src/components/ui/Checkbox'
import { UIDialog } from 'src/components/ui/Modal'
import Text from 'src/components/ui/Text'

const STORAGE_KEY = 'generator::mmdit26-lora-warning-dialog-shown'

export async function openLoraStyleKeyWarnDialog() {
  const storageVal = readLocalStorageValue({
    key: STORAGE_KEY,
    defaultValue: false,
  })
  if (storageVal === true) return Promise.resolve(true)

  return UIDialog.confirm({
    heading: (
      <Text i18nKey="generation:lora.style-key-lora-warn-dialog.heading" />
    ),
    content: <LoraWarnDialogContent />,
  })
}

function LoraWarnDialogContent() {
  const [dontShow, setDontShow] = useLocalStorage({
    key: STORAGE_KEY,
    defaultValue: false,
  })

  return (
    <div className="flex flex-col gap-4">
      <AriaLabel className="text-sm text-neutral-600 dark:text-neutral-300">
        <Text i18nKey="generation:lora.style-key-lora-warn-dialog.content" />
      </AriaLabel>
      <UICheckbox isSelected={dontShow} onChange={setDontShow}>
        <Text i18nKey="generation:lora.style-key-lora-warn-dialog.dont-show-again.label" />
      </UICheckbox>
    </div>
  )
}
